/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { ComponentCardsSimpleEditWrapper } from "./component-cards-simple-wrapper";
import { CardsSimpleItemEditor } from "./cards-simple-item";

const CardsSimpleComponentEditor = () => {

    const { component, updateFactory } = useUpdateComponent();

    const {
        card_list: cardList,
    } = component;

    const onChangeCardList = updateFactory("card_list");

    return (
        <div className='simplicity-editor-frame'>
            <ComponentCardsSimpleEditWrapper
                list={cardList}
                onChange={onChangeCardList}
            >
                <CardsSimpleItemEditor/>
            </ComponentCardsSimpleEditWrapper>
        </div>
    );
};

CardsSimpleComponentEditor.displayName = "CardsSimpleComponentEditor";
export { CardsSimpleComponentEditor };
